import {OnInit, Pipe, PipeTransform, OnChanges, Input, Output, EventEmitter, Component} from '@angular/core';
import {Observable} from 'rxjs';

import {Broker} from '@c4/core';

import * as _ from 'lodash';

declare var _: any;

@Pipe({
  name: 'labelize'
})
export class LabelizePipe implements PipeTransform {
  transform(value: string): string {
    return _.startCase(value.replace('_', ' '));
  }
}

@Component({
  selector: 'prg-param-editor',
  templateUrl: './param-editor.html',
  // inputs: ['params'],
  // outputs: ['done'],
  styleUrls: [
    './param-editor.css'
  ]
})
export class ParamEditorComponent implements OnInit, OnChanges {

  @Input() params: Array<any>;

  @Output() done: EventEmitter<any>;

  private deferralTimeouts: Map<string, any>;

  // config: C4InputConfig = {
  //   layout: 'horizontal',
  //   labelColumns: 3,
  //   inputColumns: 3
  // };

  constructor(
    private broker: Broker
  ) {
    console.log('prmedt: ctor');
    this.deferralTimeouts = new Map<string, any>();
    this.done = new EventEmitter<any>();
  }

  ngOnChanges(changes: any) {
    console.log('param-editor: changes', changes);
  }

  ngOnInit() {
    console.log('prmedt: oninit');
  }

  setValue(param: any, source: any, defer: boolean) {
    let timeout = this.deferralTimeouts.get(param.name);
    if (timeout) {
      clearTimeout(timeout);
      this.deferralTimeouts.delete(param.name);
      timeout = null;
    }

    if (defer) {
      // note: we do this to debounce changes due to rapid user input
      timeout = setTimeout(() => {
        param.value = source.value;
        this.deferralTimeouts.delete(timeout);
      }, 500);

      this.deferralTimeouts.set(param.name, timeout);
    } else {
      param.value = source.value;
    }
  }

  getValues(param): Observable<any> {
    if (param.values) {
      // static
      return Observable.from(param.values);
    } else {
      // dynamic // TODO
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/param-editor/param-editor.ts